/* eslint-disable */
// TODO: Lint cleanup. If you are editing this file, it is your duty to fix all linting errors.
import { connect } from 'react-redux'
import { selectors as authSelectors } from '@hixme/auth-ui'
import { ROLE_PLATFORM_HIXME_ADMIN, ROLE_BROKER } from '@hixme/role-policy'
import * as personSelectors from 'store/modules/persons/selectors'
import { logout } from 'store/modules/user-session/actions'
import SideNav from 'components/SideNav'

const mapStateToProps = (state) => {
  const { userRole } = authSelectors.getCredentials(state)
  const isHixmeAdmin = [ROLE_PLATFORM_HIXME_ADMIN, ROLE_BROKER].indexOf(userRole) > -1

  return {
    person: personSelectors.getPersonSelector(state),
    isAdmin: isHixmeAdmin,
  }
}

export default connect(
  mapStateToProps,
  (dispatch) => ({
    logout: (e) => {
      e.preventDefault()
      dispatch(logout())
    },
  })
)(SideNav)
